import { Link } from "react-router";
import { cn } from "@util/helpers";

type CardGroupedListItemProps = {
  /** The id of the article */
  id: string;
  /** The Article link to be redirected */
  link: string;
  /** The title of the article */
  title: string;
};

/**
 * Renders a list of grouped article cards.
 * Figma: https://www.figma.com/design/rR8akVWS3SksIyaOSqetu4/BAU--WEB---APP-?node-id=15283-30089&t=e9A81BzeElIUYdlc-4
 */
const CardGroupedListItem = ({
  link,
  title,
}: CardGroupedListItemProps): React.ReactElement | null => {
  return (
    <li className={cn("relative py-2 text-gray-550")}>
      <Link
        to={link}
        className={cn(
          "text-white hover:underline",
          "before:absolute before:-left-4 before:right-0 before:top-0 before:h-px before:bg-gray-750 before:content-['']"
        )}
        data-testid="card-grouped-list-item-component"
      >
        {title}
      </Link>
    </li>
  );
};

export default CardGroupedListItem;
